import { Button } from "@tblabs/truffle";
import { XButton } from "./XButton";


export class XDangerButton extends XButton
{
    constructor(text: string, icon: string, onClick: (btn: Button) => void)
    {
        super("danger", text, icon, onClick);
    }
}
